import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, NavLink, useLocation } from "react-router-dom";
import { VscThreeBars } from "react-icons/vsc";
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";
import { FiExternalLink } from "react-icons/fi";
import { FaFacebookF, FaYoutube, FaInstagram } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";
import { GoDotFill } from "react-icons/go";
import { HiUser, HiOutlineLogout } from "react-icons/hi";
import { Modal } from "react-bootstrap";
import AppContext from "../../context/AppContext";
import ApiService from "../../api/ApiService";
import notification from "../../helpers/notification";
import { RiLiveFill } from 'react-icons/ri'
import axios from "axios";
import CryptoJS from "crypto-js";


const expiry = process.env.REACT_APP_OTPEXPIRY;
let timer = null;

const Header = ({ setOpened }) => {
  const { loginPopup, setLoginPopup, token, setToken, user, donor, setDonor } =
    useContext(AppContext);

  const [isScroll, setIsScroll] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const updateOnScroll = () =>
    window.addEventListener("scroll", () =>
      window.scrollY > 20 ? setIsScroll(true) : setIsScroll(false)
    );

  useEffect(() => {
    updateOnScroll();
  }, []);

  const [otpSent, setOtpSent] = useState(false);
  const [number, setNumber] = useState("");

  const [otp, setOtp] = useState("");

  const [otpExp, setOtpExp] = useState(expiry);
  const [resendtimes, setResendTimes] = useState(0);
  const [showresendlink, setShowResendLink] = useState(false);
  const [isWatchLive, setIsWatchLive] = useState(false)
  const [showTimer, setShowTimer] = useState(true)
  const [btnDisabled, setBtnDisabled] = useState(false)
  const [seticsmob, SetIcsmob] = useState([])

  const hasWatchLive = async () => {
    const { liveVideos } = await ApiService.hasWatchLive()
    setIsWatchLive(liveVideos)
  }
      
  // if(showresendlink){
  //   navigate("/donation-form")
  //   setLoginPopup(false)
  //   setShowResendLink(false)
  // }
  //console.log(resendtimes)
  if (resendtimes == 2) {
    navigate("/donation-form")
    setResendTimes(0)
    setLoginPopup(false)
    setShowResendLink(false)
    setOtpSent(false)
  }

  function getTime(time) {
    return (
      Math.floor(time / 60) + ":" + ("0" + Math.floor(time % 60)).slice(-2)
    );
  }


  const logOut = () => {
    localStorage.removeItem("token");
    setToken(null);
    navigate("/");
    localStorage.removeItem('icsmob');
    localStorage.removeItem('ics_mob');
    localStorage.removeItem('ics_id');
    localStorage.removeItem('multiplesevatype');
    localStorage.removeItem('multiplesevaPrice');
    localStorage.removeItem('multiplesevaName');
    localStorage.removeItem('ics_number');
    localStorage.removeItem('dms_id');

    localStorage.removeItem('ics_all_data');

  };

  // const settingDefault = async (number) => {
  //   const data = {
  //     phone: number,
  //     donor_id: localStorage.getItem('dms_id'),
  //   }

  //   const response = await ApiService.fetchDonor(data);
  //   console.log(response)

  //   const encryptedData = CryptoJS.AES.encrypt(response.profiles[0]?.phone, process.env.REACT_APP_CSCKEY).toString();
    
  //   // localStorage.setItem('ics_id', response.profiles[0]?.id);
  //   // localStorage.setItem('ics_name', response.profiles[0]?.legal_name);
  //   localStorage.setItem('ics_number', encryptedData);
  //   window.location.reload(true);
  // }



  const handleSendOtp = async (resend = false) => {
    const getmob = localStorage.getItem('icsmob');
    if (getmob) {
      setNumber(localStorage.getItem('icsmob'))
    }

    if (timer) {
      clearInterval(timer)
    }
    if (number.length >= 10) {
      try {
        setBtnDisabled(true)
        const res = await ApiService.sendOtp({ number, resend });
        notification("success", res.message);
        setBtnDisabled(false)
        timer = setInterval(() => {
          setOtpExp(prev => prev - 1)
        }, 1000)

        setOtpSent(true);
      } catch (err) {
        console.log(err);
        if (err.response.status === 400) {
          notification('warning', err.response.data.message)
        } else {
          if (err.response.data.message == 'No donation found for the given mobile number!') {
            navigate("/donation-form")
            setLoginPopup(false);
            notification('error', err.response.data.message)
          } else {
            notification("error", err.response.data.message);
            navigate("/donation-form")
            setLoginPopup(false);
          }
        }
        setBtnDisabled(false)
      }
    } else {
      notification("warning", 'Please Enter Valid Number');
      setBtnDisabled(false)
    }
  };


  const handleLogin = async () => {

    if (otp.length >= 6) {
      try {
        let data = {
          number,
          otp,
        };

        const res = await ApiService.loginUser(data);
       // console.log("res.success", res.success)

        if (res.success) {
          localStorage.setItem("dms_id", res?.user?.dmsDonorId)
          localStorage.setItem(`token`, res.token);
          setToken(res.token);
          setLoginPopup(false);
          notification("success", res.name + ' ' + res.message);
          navigate("/dashboard")
          setOtpSent(false);
          setOtp('')
        }
      } catch (err) {
        // console.log(err);
        notification("error", err?.response?.data?.message);
        navigate("/donation-form")

      }
    } else {
      notification("warning", 'Please Enter Valid OTP');

    }
  };

  function setCookie(name, value) {
    let expires = "";
    let date = new Date();
    date.setTime(date.getTime() + (1 * 60 * 1000));
    expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  const resendOtp = () => {
    setShowResendLink(false)

    if (getCookie("limitReached2")) {
      notification('warning', 'Resend OTP limit has been reached!')
      setResendTimes(0)
      setShowTimer(false)
    } else {
      if (resendtimes < 2) {
        setOtpExp(expiry)
        handleSendOtp(true)
        setResendTimes(prev => prev + 1)
      } else {
        setCookie("limitReached2", true)
        notification('warning', 'Resend OTP limit has been reached!')
        setShowTimer(false)
      }
    }
  }

  const handleNavigate = () => {
    navigate("/donate");

    // setTimeout(() => {

    //   const scrollToDonateFromRef = document.getElementById('scrollToDonateFrom3ndPage');


    //   if (scrollToDonateFromRef) {
    //     const offset = -600;
    //     const targetScrollTop = scrollToDonateFromRef.offsetTop - offset;

    //     const container = document.documentElement;

    //     container.scrollTop = targetScrollTop;
    //   } else {
    //     console.error("Element scrollToDonateFromRef not found!");
    //   }
    // }, 1000);


    // window.location.reload();
  };

  const handleHideModal = () => {
    setLoginPopup(false);
  };

  useEffect(() => {
    hasWatchLive()
    setNumber(localStorage.getItem('icsmob'))

  }, [])

  useEffect(() => {
    if (otpExp === 0) {
      setShowResendLink(true)
      clearInterval(timer)
      setOtpExp(expiry)
    }
  }, [otpExp, expiry])

  const quickDonateBtn = () => {
    localStorage.removeItem('SpecialOccassionAmount')
    localStorage.removeItem('responseData');
    navigate('/donation-form')
    // setTimeout(() => {

    //   const scrollToDonateFromRef = document.getElementById('scrollToDonateFrom');


    //   if (scrollToDonateFromRef) {
    //     const offset = -600;
    //     const targetScrollTop = scrollToDonateFromRef.offsetTop - offset;

    //     const container = document.documentElement;

    //     container.scrollTop = targetScrollTop;
    //   } else {
    //     console.error("Element scrollToDonateFromRef not found!");
    //   }
    // }, 1000);
    localStorage.removeItem('multiplesevatype');

    localStorage.removeItem('multiplesevaPrice');

    localStorage.removeItem('multiplesevaName');

  }




  return (
    <>
      <header className={isScroll ? "scroll" : ""}>
        <div className="container">
          <div className="mobile-top-menu d-none">
            <ul className="list-unstyled mb-0">
              {
                isWatchLive &&
                <li>
                  <Link className="live" to="/watch-live"> <GoDotFill /> Watch Live</Link>
                </li>
              }
              <li>
                <Link to="/donation-form" onClick={quickDonateBtn}>
                  <svg width="20" height="20" viewBox="0 0 512 512">
                    <g id="#000000ff">
                      <path
                        fill="#9F1D21"
                        opacity="1.00"
                        d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                      />
                      <path
                        fill="#9F1D21"
                        opacity="1.00"
                        d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                      />
                    </g>
                  </svg>
                  Quick Donate
                </Link>
              </li>
              <li>
                {
                  token ?
                    <>
                      <Link to="/dashboard"><HiUser /> <span>Dashboard</span></Link>
                      <Link onClick={logOut}><HiOutlineLogout /> <span>Logout</span></Link>
                    </>
                    :
                    <button onClick={() => navigate("/dashboard")}><HiUser /> <span>Loginn</span></button>
                }
              </li>
            </ul>
          </div>

          <div className="top-nav">
            <ul className="social-icons list-unstyled mb-0">
              {
                isWatchLive &&
                <li className="me-3 d-lg-inline-block d-none">
                  <button onClick={() => navigate('/watch-live')}>
                    <GoDotFill /> <span>Watch Live</span>
                  </button>
                </li>
              }
              <li>
                <a target="_blank" href="https://facebook.com/iskconbhiwandi"><FaFacebookF /></a>
              </li>
              <li>
                <a target="_blank" href="https://www.youtube.com/ISKCONBHIWANDI"><FaYoutube /></a>
              </li>
              <li>
                <a target="_blank" href="https://www.instagram.com/iskconbhiwandi"><FaInstagram /></a>
              </li>
              <li>
                {token ? (
                  <>
                    {
                      location?.pathname?.includes('/ics') ? (
                        <span style={{ textTransform: "uppercase" }}>WELCOME  {user?.name}  </span>

                      ) : (
                        <span style={{ textTransform: "uppercase" }}>  {!donor ? '' : "WELCOME"} {donor?.legal_name}  </span>
                      )
                    }
                  </>
                ) : (
                  <span> </span>
                )}
              </li>
            </ul>
            <span className="logo">
              <Link to="/">
                <img src="/images/common/logo.png" alt="" />
              </Link>
            </span>

            <ul className="login-wrap list-unstyled mb-0">

              <li className="me-lg-3 d-none d-lg-inline-block">
                <button onClick={quickDonateBtn} >
                  <svg width="20" height="20" viewBox="0 0 512 512">
                    <g id="#000000ff">
                      <path
                        fill="#9F1D21"
                        opacity="1.00"
                        d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                      />
                      <path
                        fill="#9F1D21"
                        opacity="1.00"
                        d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                      />
                    </g>
                  </svg>
                  Quick Donate
                </button>
              </li>
              <li className="d-lg-none d-block">

                <button
                  className="m-0 pe-2 ps-1 box-hover animation"
                  onClick={handleNavigate}
                >
                  <div className="anination-wrap">
                    <div className="heart">
                      <svg width="24" height="24" viewBox="0 0 512 512">
                        <g id="#000000ff">
                          <path
                            fill="#fff"
                            opacity="1.00"
                            d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                          />
                          <path
                            fill="#fff"
                            opacity="1.00"
                            d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="ripple"></div>
                  </div>
                  Donate
                </button>
              </li>
              {token ? (
                <li className="d-lg-none d-block">

                  <button
                    className="m-0 pe-2 ps-1 box-hover animation"
                    onClick={logOut}
                  >
                    <div className="anination-wrap">

                      <HiOutlineLogout />


                    </div>
                    Logout
                  </button>
                </li>
              ) : (
                ''
              )}

              <li className="d-none d-lg-inline-block">
                {token ? (
                  <>
                    <button onClick={() => navigate("/dashboard")}>
                      <HiUser /> <span>Dashboard </span>
                    </button>

                  </>

                ) : (
                  <button className="login-msg" onClick={() => setLoginPopup(true)}>
                    <HiUser /> <span>Login</span>
                    <p className="mb-0">To view previous receipt</p>
                  </button>
                )}
              </li>
              <li className="d-none d-lg-inline-block">
                {token ? (
                  <>
                    <button className="" onClick={logOut}>
                      <HiOutlineLogout /> <span>Logout</span>
                    </button>
                  </>

                ) : (
                  ''
                )}
              </li>
              <li>
                <button
                  className="toggle-side-menu"
                  onClick={() => setOpened(true)}
                >
                  <VscThreeBars />
                </button>
              </li>
            </ul>
          </div>
          <nav>
            <ul className="list-unstyled nav-list">
              <li>
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to="/"
                >
                  Home
                </NavLink>
              </li>

              <li className="drop-menu">
                <button
                  className="drop-btn"
                  onClick={() => navigate("/about-us")}
                >
                  About <AiFillCaretDown />
                </button>
                <div className="sub-menu">
                  <ul className="list-unstyled">
                    <li>
                      <Link to="/about-us/#mission">ISKCON Mission</Link>
                    </li>
                    <li>
                      <Link to="/about-us/#founder">Founder</Link>
                    </li>
                    <li>
                      <Link to="/about-us/#temple">
                        Sri Sri Radha Madhava Temple
                      </Link>
                    </li>
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/daily-darshan-gallery"
                      >
                        Daily Darshan
                      </NavLink>
                    </li>
                    <li>
                      <Link to="/gaudiya-vaishnavism">Gaudiya Vaishnavism</Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="drop-menu">
                <button
                  className="drop-btn"
                  onClick={() => navigate("/services")}
                >
                  Services <AiFillCaretDown />
                </button>
                <div className="sub-menu">
                  <ul className="list-unstyled">
                    <li>
                      <Link to="/courses">Courses</Link>
                    </li>
                    <li>
                      <Link to="/services">Services</Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to="/movement"
                >
                  Hare Krishna Movement
                </NavLink>
              </li>
              <li className="drop-menu">
                <button className="drop-btn">
                  Events <AiFillCaretDown />
                </button>
                <div className="sub-menu">
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="redirect-link"
                        href="https://iskcontsp.org/"
                        target="_blank"
                      >
                        Harinam Sankirtan <FiExternalLink />
                      </a>
                    </li>
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/festivals"
                      >
                        Festivals
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/yatras"
                      >
                        Yatras
                      </NavLink>
                    </li> */}
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/Recent-Events"
                      >
                        Recent Events
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/gallery"
                      >
                        Gallery
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/classes-video"
                      >
                        Classes Videos
                      </NavLink>
                    </li> */}
                  </ul>
                </div>
              </li>
              <li className="drop-menu">
                <button className="drop-btn">
                  Support us <AiFillCaretDown />
                </button>
                <div className="sub-menu">
                  <ul className="list-unstyled">
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive
                            ? "active donate-button-clicked-header-menu"
                            : "donate-button-clicked-header-menu"
                        }
                        to="/donate-categories"
                      >
                        Donate
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to="/volunteer"
                      >
                        Volunteer
                      </NavLink>
                    </li>
                    <li className="has-submenu">
                      {/* <NavLink
                        className={(navData) =>
                          navData.isActive ? "active" : ""
                        }
                        to=""
                      >
                        Food For Life
                      </NavLink> */}
                      <span className="anc">Food For Life <AiFillCaretRight /></span>
                      <ul className="mb-0 list-unstyled">
                        <li>
                          <Link to="/about-annadaan">About</Link>
                        </li>
                        <li>
                          <Link to="/annadaan">Donate</Link>
                        </li>
                        {/* <li>
                          <Link to="/Special-Occassion">Special Occassion</Link>
                        </li> */}
                      </ul>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to="/connect"
                >
                  Connect
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={(navData) => (navData.isActive ? "active" : "")}
                  to="/shop"
                >
                  Shop
                </NavLink>
              </li>
              <li>
                <button
                  className="m-0 px-3 custom-btn-cls box-hover animation donate-button-clicked-header"
                  onClick={handleNavigate}
                >
                  <div className="anination-wrap">
                    <span className="heart">
                      <svg width="24" height="24" viewBox="0 0 512 512">
                        <g id="#000000ff">
                          <path
                            fill="#fff"
                            opacity="1.00"
                            d=" M 240.87 0.00 L 271.11 0.00 C 271.12 23.56 271.10 47.13 271.12 70.69 C 278.55 78.00 285.73 85.57 292.93 93.12 C 292.95 76.54 292.92 59.97 292.94 43.40 C 303.02 43.40 313.09 43.40 323.17 43.40 C 323.19 71.57 323.17 99.73 323.18 127.90 C 331.42 138.10 339.26 148.61 346.63 159.46 C 346.64 137.37 346.62 115.29 346.64 93.20 C 356.72 93.20 366.79 93.20 376.87 93.20 C 376.87 136.13 376.90 179.05 376.86 221.98 C 376.42 229.97 377.25 237.98 376.38 245.95 C 373.97 274.61 360.71 302.13 339.99 322.05 C 321.42 340.19 296.85 351.94 271.12 355.21 C 271.11 366.91 271.11 378.61 271.12 390.31 C 286.65 375.79 305.12 364.48 325.08 357.17 C 354.11 346.30 378.78 324.33 392.85 296.70 C 397.90 286.96 401.26 276.47 405.23 266.27 C 410.15 253.23 415.05 240.18 419.97 227.14 C 429.42 230.65 438.85 234.21 448.27 237.80 C 440.90 257.30 433.64 276.84 426.18 296.30 C 413.01 329.98 387.76 358.74 356.03 376.10 C 348.32 380.37 340.21 383.86 331.96 386.95 C 315.05 393.61 299.63 404.02 287.06 417.14 C 281.25 423.07 276.36 429.82 271.12 436.25 C 271.11 442.92 271.10 449.59 271.12 456.26 C 286.53 443.79 303.78 433.67 322.10 426.12 C 337.73 419.29 354.63 416.05 370.31 409.34 C 397.37 398.12 422.44 380.48 439.16 356.12 C 445.07 347.64 449.30 338.18 453.88 328.96 C 460.97 314.57 468.03 300.16 475.14 285.78 C 484.16 290.28 493.22 294.67 502.25 299.16 C 492.88 318.18 483.57 337.21 474.16 356.20 C 460.74 382.95 438.96 404.91 413.77 420.77 C 395.81 432.18 376.04 440.59 355.60 446.40 C 337.32 451.62 319.68 459.31 303.76 469.75 C 290.89 477.89 280.11 488.71 269.24 499.25 C 265.08 503.53 260.27 507.21 256.67 512.00 L 255.34 512.00 C 248.74 504.20 240.80 497.65 233.66 490.36 C 216.69 473.19 195.66 460.33 173.13 451.81 C 165.00 448.65 156.58 446.37 148.26 443.77 C 129.82 437.90 112.09 429.70 95.87 419.13 C 71.70 403.40 50.81 382.00 37.85 356.08 C 28.43 337.09 19.11 318.05 9.76 299.04 C 18.80 294.59 27.83 290.11 36.90 285.71 C 43.21 298.54 49.53 311.37 55.84 324.20 C 62.31 337.10 68.00 350.59 77.15 361.91 C 98.72 389.55 130.67 407.44 163.99 416.98 C 191.82 424.87 218.38 437.79 240.85 456.12 C 240.88 449.46 240.86 442.80 240.87 436.14 C 235.52 429.50 230.46 422.58 224.45 416.51 C 214.99 406.68 203.88 398.49 191.81 392.16 C 181.54 386.69 170.20 383.61 159.95 378.09 C 126.61 361.07 99.83 331.67 86.08 296.85 C 78.51 277.18 71.21 257.41 63.73 237.71 C 73.15 234.11 82.60 230.62 92.02 227.02 C 99.34 246.35 106.55 265.72 113.92 285.04 C 124.85 313.15 146.28 336.97 173.08 350.82 C 181.14 355.21 189.96 357.90 198.29 361.70 C 213.93 368.76 228.29 378.51 240.87 390.17 C 240.86 378.51 240.87 366.86 240.87 355.21 C 211.10 351.48 183.03 336.20 163.73 313.25 C 144.91 291.15 134.38 262.05 135.21 233.00 C 134.98 186.40 135.15 139.80 135.11 93.20 C 145.18 93.20 155.26 93.20 165.34 93.20 C 165.36 115.29 165.33 137.38 165.36 159.47 C 171.00 151.17 176.88 143.02 183.09 135.14 C 184.73 133.01 186.64 131.05 187.89 128.65 C 188.51 125.47 188.14 122.21 188.20 119.00 C 188.18 93.80 188.19 68.60 188.19 43.40 C 198.27 43.41 208.35 43.39 218.43 43.41 C 218.44 60.21 218.43 77.01 218.44 93.81 C 225.83 86.03 233.20 78.23 240.86 70.72 C 240.87 47.15 240.86 23.57 240.87 0.00 M 185.74 183.64 C 177.92 196.25 170.60 209.46 166.88 223.92 C 164.77 231.83 165.17 240.13 166.28 248.16 C 169.13 268.55 179.32 287.78 194.47 301.71 C 208.29 314.61 226.26 322.97 245.04 325.20 C 264.50 327.61 284.73 323.49 301.62 313.50 C 321.67 301.88 336.92 282.28 343.18 259.96 C 346.67 247.01 348.32 232.93 344.00 219.97 C 338.59 202.94 329.12 187.57 319.15 172.88 C 300.53 146.10 278.79 121.63 256.00 98.35 C 230.28 124.75 205.59 152.49 185.74 183.64 Z"
                          />
                          <path
                            fill="#fff"
                            opacity="1.00"
                            d=" M 243.47 185.63 C 255.90 183.14 269.24 185.31 280.14 191.81 C 293.18 199.46 302.60 213.03 305.01 227.97 C 307.31 241.25 304.15 255.36 296.36 266.36 C 288.25 278.07 275.13 286.21 260.99 288.09 C 245.71 290.35 229.59 285.24 218.36 274.65 C 208.71 265.74 202.62 253.07 201.87 239.94 C 201.02 227.39 204.94 214.59 212.72 204.71 C 220.27 194.96 231.38 188.06 243.47 185.63 M 249.14 215.33 C 239.25 217.31 231.61 226.89 231.98 236.99 C 231.96 247.10 239.95 256.46 249.93 258.04 C 259.70 259.99 270.20 254.16 273.86 244.94 C 277.20 237.15 275.36 227.54 269.42 221.51 C 264.33 216.12 256.38 213.73 249.14 215.33 Z"
                          />
                        </g>
                      </svg>
                    </span>
                    <span className="ripple"></span>
                  </div>
                  Donate
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <Modal centered show={loginPopup} onHide={handleHideModal}>
        <div className="auth-modal">
          <button className="btn close-svg" onClick={handleHideModal}>
            <MdOutlineClose />
          </button>
          <div className="row align-items-center">
            <div className="col-md-6 d-sm-block d-none pe-md-0">
              <div className="popup-left-side">
                <figure className="bg_img">
                  <img src="/images/common/bg-line.jpg" alt="" />
                </figure>
                <div className="left-content">
                  <h4>Login</h4>
                  <div className="main-content">
                    <h3>
                      Log-in to save your details, view donation history and <span> download 80G certificate </span> conveniently.
                    </h3>
                  </div>
                </div>
                <figure className="popup-img">
                  <img src="/images/modal/hare-krishna-logo.svg" alt="" />
                </figure>
              </div>
            </div>
            <div className="col-md-6 ps-md-0">
              {otpSent ? (
                <div className="pop-up-form">
                  <div className="pop-up-top">
                    <div className="heading">
                      <h2 className="head-2">OTP Verification</h2>
                    </div>
                  </div>
                  <p>Enter the OTP sent to +91 {number} and on your registered mail id.</p>
                  <form action="" className="mt-3 mt-sm-0">
                    <div className="row align-items-center">
                      <div className="col-12">
                        <div className="label-input-wrap">
                          <input
                            type="tel"
                            id="otp"
                            name="otp"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            minLength={6}
                            maxLength={6}
                            placeholder="Enter OTP"
                          />
                        </div>
                        {
                          (!showresendlink && showTimer) &&
                          <div className="time-wrap">
                            <p className="mb-0">Resend OTP in</p>
                            <span className="timer_span d-inline-block">{getTime(otpExp)}s</span>
                          </div>
                        }
                      </div>
                    </div>
                    <div className={`pop-form-btn ${otp.length !== 6 ? 'disabled' : ''}`}>
                      <button
                        className="box-hover"
                        type="button"
                        onClick={handleLogin}

                      >
                        Verify
                      </button>
                    </div>
                    {
                      showresendlink &&
                      <div className="time-wrap mt-4">
                        <p className="mb-0">Not yet received OTP?</p>
                        <button onClick={resendOtp} type='button'>Resend OTP</button>
                      </div>
                    }
                    <div className="time-wrap mt-4">
                      <p className="mb-0">Change number?</p>
                      <button onClick={() => setOtpSent(false)} type='button'>Click here</button>
                    </div>

                  </form>
                </div>
              ) : (
                <div className="pop-up-form">
                  <div className="pop-up-top">
                    <div className="heading">
                      <h2 className="head-2">Login</h2>
                    </div>
                  </div>
                  <p>We will send you an OTP on this mobile number and on your registered mail id.</p>
                  <form action="" className="mt-3 mt-sm-0">
                    <div className="row align-items-center m-0">
                      <div className="col-12 px-0">
                        <div className="label-input-wrap">
                          <input
                            type="tel"
                            id="number"
                            name="number"
                            placeholder="Enter Mobile Number"
                            defaultValue={localStorage.getItem('icsmob') ? localStorage.getItem('icsmob') : number}
                            required
                            onChange={(e) => setNumber(e.target.value)}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            minLength={10}
                            maxLength={10}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={`pop-form-btn ${!number || number.length !== 10 ? 'disabled' : ''}`}>

                      <button
                        className="box-hover"
                        type="button"
                        onClick={() => { handleSendOtp() }}
                        disabled={btnDisabled}
                      >
                        Get OTP
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Header;
